
export function uploadDisplayName({ description, path }) {
  return description || path;
}
